/* eslint-disable no-nested-ternary */
import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { MathJax } from "better-react-mathjax";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import { Stack } from "@mui/material";
import East from "@mui/icons-material/East";
import West from "@mui/icons-material/West";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { FormattedMessage } from "react-intl";
import { DebuggerMessage, answerMapping } from "../../../../utils/constants/constants";
import { ShowBasicDataContent } from "../Elements";
import { quizAnswerType } from "../../utils/constant";
import XCircle from "../../../../../public/assets/icons/XCircle";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

export function DisplayQuizPDF({ file, isRedo }) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const parentRef: any = useRef();
  const [numOfPages, setNumOfPages] = useState<any>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [widthPdf, setWidthPdf] = useState<number>(0);

  const nextPage = () => {
    setPageNumber(pageNumber + 1);
  };
  const prevPage = () => {
    setPageNumber(pageNumber - 1 > 0 ? pageNumber - 1 : 1);
  };

  useEffect(() => {
    if (isRedo) {
      setPageNumber(1);
    }
  }, [isRedo]);
  useEffect(() => {
    setWidthPdf(parentRef?.current?.clientWidth);
  }, [parentRef?.current]);
  return (
    <Box mt={3} display="flex" ref={parentRef} flexDirection="column">
      <Document
        file={file}
        onLoadSuccess={(pdf) => {
          const { numPages } = pdf;
          setNumOfPages(numPages);
        }}
        onLoadError={(e) => DebuggerMessage(e)}
        loading
        className="mt-[-12px]"
      >
        <Page pageNumber={pageNumber} renderMode="svg" width={widthPdf} />
      </Document>
      <Stack direction="row" justifyContent="center" alignItems="center" spacing={2}>
        <Button
          variant="text"
          onClick={prevPage}
          startIcon={<West className="sm:w-[15px] lg:w-[20px]" />}
          disabled={pageNumber <= 1}
          className={`${
            pageNumber <= 1 ? "text-gray1" : "text-green"
          } normal-case  border-green sm:text-[12px] lg:text-[14px]`}
        >
          <FormattedMessage id="IDS_Previous_Btn" />
        </Button>
        <Button
          variant="text"
          onClick={nextPage}
          endIcon={<East className="sm:w-[15px] lg:w-[20px]" />}
          disabled={pageNumber >= numOfPages}
          className={`normal-case border-green sm:text-[12px] lg:text-[14px] ${
            pageNumber >= numOfPages ? "text-gray1" : "text-green"
          }`}
        >
          <FormattedMessage id="IDS_Next_Btn" />
        </Button>
      </Stack>
    </Box>
  );
}

export function AnswerQuizPDF({
  dataList,
  answerTotal,
  chooseAnswerOfOneAnswerQuestion,
  chooseAnswerOfManyAnswerQuestion,
  showSolutionPDF,
  resultSolution,
  isDialog
}: any) {
  const checkShowResultPDF = (questionId, optionId) => {
    // TODO thêm check letter, word
    if (!answerTotal?.length) return false;
    const answerQuestion = answerTotal?.findIndex(
      (ele) => ele.question_id === questionId && ele.selections.includes(optionId)
    );
    return answerQuestion > -1;
  };
  const quizSolution = (questionId) => {
    return resultSolution?.find((res) => res?.quiz_question_id === questionId);
  };
  const checkOptionShowSolution = (questionId, optionId) => {
    return quizSolution(questionId)?.correct_options.includes(optionId);
  };
  return (
    <Box
      style={{
        display: "flex",
        flexWrap: "wrap",
        marginTop: 8,
        maxHeight: 500,
        overflow: "auto"
      }}
      className="text-[13px] text-gray400"
    >
      {dataList
        ?.filter(
          (qs) => qs?.answer_type === quizAnswerType.ONE_ANSWER || qs?.answer_type === quizAnswerType.MANY_ANSWER
        )
        .map((question: any, index: number) => (
          <div key={question?.id} className="flex py-1.5 w-full items-center">
            <span className={`font-semibold w-[24px] ${isDialog && "ml-4"}`}>{index + 1}</span>
            <div
              className={`flex justify-start md:gap-[20px] lg:gap-[30px] w-[calc(100%-24px)] flex-wrap ${
                isDialog && "gap-[30px]"
              }`}
            >
              {question?.options?.map((op, idx) => (
                <button
                  type="button"
                  key={idx}
                  onClick={() =>
                    resultSolution
                      ? checkOptionShowSolution(question?.id, op?.id)
                        ? showSolutionPDF(question?.id, index + 1)
                        : null
                      : question?.answer_type === quizAnswerType.ONE_ANSWER
                      ? chooseAnswerOfOneAnswerQuestion(op?.id, question?.id)
                      : chooseAnswerOfManyAnswerQuestion(op?.id, question?.id)
                  }
                  className={`border ${
                    resultSolution
                      ? (() => {
                          if (
                            quizSolution(question?.id)?.correct &&
                            quizSolution(question?.id)?.correct_options.includes(op?.id)
                          ) {
                            return "bg-greenQuiz text-white";
                          }

                          if (
                            quizSolution(question?.id)?.skipped &&
                            quizSolution(question?.id)?.correct_options.includes(op?.id)
                          ) {
                            return "bg-orangeQuiz text-white";
                          }

                          const isWrongAnswerQuiz =
                            !quizSolution(question?.id)?.skipped && !quizSolution(question?.id)?.correct;
                          if (isWrongAnswerQuiz) {
                            if (
                              quizSolution(question?.id)?.answered_options.includes(op?.id) &&
                              !quizSolution(question?.id)?.correct_options.includes(op?.id)
                            ) {
                              return "bg-red text-white";
                            }

                            if (
                              quizSolution(question?.id)?.answered_options.includes(op?.id) &&
                              quizSolution(question?.id)?.correct_options.includes(op?.id)
                            ) {
                              return "bg-greenQuiz text-white";
                            }

                            if (
                              !quizSolution(question?.id)?.answered_options.includes(op?.id) &&
                              quizSolution(question?.id)?.correct_options.includes(op?.id)
                            ) {
                              if (question?.answer_type === quizAnswerType.ONE_ANSWER) return "bg-greenQuiz text-white";
                              return "bg-purple text-white";
                            }
                          }

                          return "bg-white border border-gray";
                        })()
                      : checkShowResultPDF(question?.id, op?.id)
                      ? "border-greenQuiz text-greenQuiz bg-white"
                      : "border-gray bg-white"
                  } rounded-full w-[32px] h-[32px] flex items-center justify-center`}
                >
                  <span className="ml-[-1px]">{answerMapping(idx + 1)}</span>
                </button>
              ))}
            </div>
          </div>
        ))}
    </Box>
  );
}

export function PopupShowSolutionPDF({ open, setOpen, data }) {
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" textAlign="center">
        <span className="text-title">
          <FormattedMessage id="IDS_Solution_Guide" values={{ index: data?.index }} />
        </span>
        <button
          type="button"
          onClick={handleClose}
          style={{
            position: "absolute",
            right: 7,
            top: 9,
            background: "white"
          }}
        >
          <XCircle />
        </button>
      </DialogTitle>
      <MathJax dynamic inline>
        <DialogContent style={{ minHeight: 291, maxHeight: "60vh" }} className="sm:w-[80vw] md:w-[560px]">
          {data?.length && data.map((e, idx) => <ShowBasicDataContent ele={e} key={idx} />)}
        </DialogContent>
      </MathJax>
    </Dialog>
  );
}
